import { render, staticRenderFns } from "./DoctorRegisterAddModal.vue?vue&type=template&id=24fe6c4a&scoped=true&"
import script from "./DoctorRegisterAddModal.vue?vue&type=script&lang=js&"
export * from "./DoctorRegisterAddModal.vue?vue&type=script&lang=js&"
import style0 from "./DoctorRegisterAddModal.vue?vue&type=style&index=0&id=24fe6c4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fe6c4a",
  null
  
)

export default component.exports